import React from 'react';
import classNames from '../../classnames.js';
import modules_a1601a7d from './title.module.scss.js';

const Title = ({ fontStyle = "content-default", bold = false, children, maxRows = 1, ellipsis = false, loading, ...rest }) => {
    const getTitleClassName = () => classNames(modules_a1601a7d[`title-${fontStyle}`], {
        [modules_a1601a7d["title-bold"]]: bold,
        [modules_a1601a7d["skeleton"]]: loading,
        [modules_a1601a7d[`skeleton-${fontStyle}`]]: loading
    });
    const renderEllipsisTitle = () => (React.createElement("div", { className: modules_a1601a7d["title-ellipsis-text"], style: { "--rows": maxRows }, suppressHydrationWarning: true },
        React.createElement("span", { className: getTitleClassName(), ...rest, "data-testid": "mbw-title-container", style: { whiteSpace: "pre-line" }, suppressHydrationWarning: true }, children)));
    const renderRegularTitle = () => (React.createElement("span", { className: getTitleClassName(), style: { "--rows": maxRows }, ...rest, "data-testid": "mbw-title-container", suppressHydrationWarning: true }, children));
    const renderTitle = () => {
        if (ellipsis)
            return renderEllipsisTitle();
        return renderRegularTitle();
    };
    return renderTitle();
};

export { Title as default };
//# sourceMappingURL=title.js.map
